import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {MegaMenuModule} from "primeng/megamenu";
import {StyleClassModule} from "primeng/styleclass";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {InputTextModule} from "primeng/inputtext";
import {BadgeModule} from "primeng/badge";
import {AuthService} from "../core/auth/auth.service";
import {AppraiserUtilsService} from "../@admin/services/utils";
import {AzureProfileResponse} from "../api/models/response/azure-profile-response";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ProfileComponent} from "../@admin/components/profile/profile.component";
import {Router} from "@angular/router";
import {NgIf} from "@angular/common";
import {InternalProductEnum} from "../@admin/utils/constant/common.const";
import { SharedService } from '../@admin/services/shared/shared.service';
import { DefaultConstConfig } from '../@admin/utils/constant';
import { EnvTypeComponent } from "./env-type/env-type.component";

@Component({
  selector: 'app-topbar',
  standalone: true,
  templateUrl: './app.topbar.component.html',
  imports: [MegaMenuModule, StyleClassModule, ButtonModule, RippleModule, InputTextModule, BadgeModule, NgIf, EnvTypeComponent]
})
export class AppTopbarComponent implements OnInit, OnDestroy {

  @ViewChild('menuButton') menuButton!: ElementRef;

  @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;

  @ViewChild('searchInput') searchInput!: ElementRef;
  profile: AzureProfileResponse = {}
  ref!: DynamicDialogRef;
  isInternalView: boolean = false;
  constructor(public layoutService: LayoutService, public el: ElementRef, public _authService: AuthService, public _utilityService: AppraiserUtilsService,
              public dialogService: DialogService,public router :Router,private _shared:SharedService) {
  }

  ngOnInit(): void {
    const currentRoute = this.router.url;
    this.isInternalView = currentRoute.includes('documentations/internal/view');
    this._utilityService.getLoggedUserProfileInfo();
    this._utilityService.profileInfo$.subscribe({
      next: (res) => {
        this.profile = res;
      }
    })
  }

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onMobileTopbarMenuButtonClick() {
    this.layoutService.onTopbarMenuToggle();
  }

  showProfileDialog() {
    this._shared.showProfileDetialsDiag()
    // this.ref = this.dialogService.open(ProfileComponent, {
    //   header: 'Profile Details',
    //   width: '30vw',
    //   modal: true,
    //   breakpoints: {
    //     '1340px': '50vw',
    //     '960px': '75vw',
    //     '640px': '90vw'
    //   },
    //   contentStyle: {'max-height': '500px', overflow: 'auto'},
    //   baseZIndex: 10000,
    // });
  }

  getNavigateToDocumentationView(): void {
    // Open the preview URL in a new window/tab
    const previewUrl = `${DefaultConstConfig.documentationInternalPreviewUrl}/${InternalProductEnum.InternalAnnualProcedures}`;
    this._shared.checkAndShowBrowserPopupBlockMsg(previewUrl);
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
